export const dict_en = {
  en: {
    translation: {
      routes: {
        welcome: 'Welcome',
        about: 'About',
        dashboard: 'Dashboard',
        user: 'User',
        board: 'Board',
        signIn: 'Sign in',
        signUp: 'Sign up',
        ufo: 'UFO',
      },
      sign: {
        signIn: 'Sign In',
        signUp: 'Sign Up',
        loginRequired: 'Login is required',
        password: 'Password',
        submit: 'Submit',
        name: 'Name',
        userName: 'User name',
        nameRequired: 'Name is required',
        nameShort: 'Name is too short',
        passwordRequired: 'Password is required',
        passwordShort: 'Password is too short',
        email: 'Email',
        registration: 'Registration',
      },
      ufo: {
        notFound: 'Page not found',
      },
      header: {
        signIn: 'Sign In',
        signUp: 'Sign Up',
        logout: 'Log out',
        lang: {
          title: 'Language',
          english: 'English',
          russian: 'Russian',
        },
        theme: {
          title: 'Theme',
          light: 'Light',
          dark: 'Dark',
        },
      },
      welcome: {
        title: 'Kanban',
        description:
          'A tool for managing your projects. Provides a visual representation of tasks and allows you to determine the amount of work, thereby increasing the efficiency of the team',
        interface: 'Simple, intuitive interface',
        dragNDrop: 'Convenient board management with Drag-n-drop',
        infinityBoards: 'Ability to create an infinite number of boards, columns and tasks',
        advantages: 'Advantages',
      },
      user: {
        title: 'User Profile',
        nameInput: 'Your Name: ',
        email: 'Email',
        emailInput: 'Email: ',
        delete: 'Delete User',
        edit: 'Edit',
      },
      addBoard: {
        createBoard: 'Create new board',
        boardName: 'Board Name',
        titleRequired: 'Title is required',
        boardDescription: 'Board description',
        descriptionRequired: 'Description is required',
        submit: 'Submit',
        cancel: 'Cancel',
      },
      addColumn: {
        createColumn: 'Create new column',
        columnName: 'Column Name',
        titleRequired: 'Title is required',
        submit: 'Submit',
        cancel: 'Cancel',
      },
      addTask: {
        createTask: 'Create new task',
        taskName: 'Task Name',
        titleRequired: 'Title is required',
        taskDescription: 'Task description',
        descriptionRequired: 'Description is required',
        assignedUser: 'Assigned user',
        submit: 'Submit',
        cancel: 'Cancel',
      },
      infoTask: {
        close: 'Close',
      },
      authError: {
        error: 'Authorization error',
        wrong: 'Login or password is wrong',
        tryAgain: 'Try again',
      },
      editBoard: {
        edit: 'Edit',
        boardName: 'Board Name',
        titleRequired: 'Title is required',
        boardDescription: 'Board description',
        submit: 'Submit',
        cancel: 'Cancel',
      },
      editColumn: {
        edit: 'Edit',
        columnName: 'Column Name',
        titleRequired: 'Title is required',
        submit: 'Submit',
        cancel: 'Cancel',
      },
      editTask: {
        edit: 'Edit',
        taskName: 'Task Name',
        titleRequired: 'Title is required',
        taskDescription: 'Task description',
        assignedUser: 'Assigned user',
        submit: 'Submit',
        cancel: 'Cancel',
      },
      editUser: {
        edit: 'Edit',
        name: 'Name',
        nameRequired: 'Name is required',
        nameShort: 'Name is too short',
        email: 'Email',
        emailRequired: 'Email is required',
        password: 'Password',
        passwordRequired: 'Password is required',
        passwordShort: 'Password is too short',
        submit: 'Submit',
        cancel: 'Cancel',
      },
      modalSession: {
        session: 'Session life-time',
        tokenExpired: 'Your session token is expired',
        understood: 'Understood',
      },
      registerError: {
        error: 'Registration error',
        exist: 'This user already exist',
        tryAgain: 'Try again',
      },
      remove: {
        remove: 'Remove',
        sure: 'Do you really want to do this?',
        yes: 'Yes',
        no: 'No',
      },
      board: {
        addColumn: 'Add column',
      },
      dashboard: {
        title: 'Dashboard',
        addBoard: 'Add board',
      },
      errorFallback: {
        wrong: 'Something went wrong',
        tryAgain: 'Try again',
      },
      info: {
        team: 'Our Team',
        gudin_name: 'Andrey Gudin',
        gudin_info: 'Frontend Developer, love cats. Design, dashboard, columns, tasks',
        yurkouski_name: 'Andrei Yurkouski',
        yurkouski_info: "Frontend Developer. Network, redux, components interactions, drag'n'drop",
        SteGlaset_name: 'Daniil Khlybov',
        SteGlaset_info: 'Frontend Developer. Team lead. Content, l18n',
      },
    },
  },
};
